// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"ee60cd96","343":"bde60f14","674":"47bbac0e","710":"79f1b539","983":"76b30b18"}[chunkId] + ".css";
};